import React from 'react';

const ReturnIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20.22" height="20.22" viewBox="0 0 20.22 20.22">
            <g id="return" transform="translate(0)">
                <path id="Path_3500" data-name="Path 3500" d="M18.041,0H2.178A2.181,2.181,0,0,0,0,2.179V18.041A2.181,2.181,0,0,0,2.178,20.22H18.041a2.181,2.181,0,0,0,2.179-2.179V2.179A2.181,2.181,0,0,0,18.041,0ZM8.1,1.185h3.955v2.9a1,1,0,0,1-.994.994H9.095A1,1,0,0,1,8.1,4.082ZM19.035,18.041a1,1,0,0,1-.994.994H2.178a1,1,0,0,1-.994-.994V2.179a1,1,0,0,1,.994-.994H6.916v2.9A2.181,2.181,0,0,0,9.095,6.261h1.967A2.181,2.181,0,0,0,13.24,4.082v-2.9h4.8a1,1,0,0,1,.994.994Zm0,0" fill="#1c1d1b"></path>
                <path id="Path_3501" data-name="Path 3501" d="M166.332,220.073h-3.646l.783-.784a.592.592,0,0,0-.838-.838l-1.795,1.795a.592.592,0,0,0,0,.838l1.795,1.795a.592.592,0,0,0,.838-.838l-.783-.783h3.646a1.946,1.946,0,1,1,0,3.891h-5.076a.592.592,0,1,0,0,1.185h5.076a3.13,3.13,0,1,0,0-6.261Zm0,0" transform="translate(-154.319 -209.657)" fill="#1c1d1b"></path>
            </g>
        </svg>
    );
};

export default ReturnIcon;